import React, { useEffect, useState, useRef } from 'react';
import { fetchData } from '../utils/apiHelpers';
import { getAll } from '../api';
import $ from 'jquery';
import { Icon } from '@iconify/react';
import { useUserProfile } from '../masterLayout/MasterLayoutBody';
import Select from 'react-select';
import {
  createPlantStatus,
  updatePlantStatus,
  deletePlantStatus,
  getPlantStatus
} from '../api/plant-statusAPI';

const PlantStatusListLayer = () => {
  const userProfile = useUserProfile();
  const [statusList, setStatusList] = useState([]);
  const [colours, setColourList] = useState([]);
  const [newStatus, setNewStatus] = useState({});
  const [editingId, setEditingId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [errors, setErrors] = useState({});

  const tableRef = useRef(null);
  const dtRef = useRef(null);

  const colourOptions = colours.map(c => ({
    value: c.id,
    label: c.name,
    bootstrapName: c.bootstrapName,
  }));

  const fetchStatuses = () => {
    fetchData(getPlantStatus, {}, setStatusList);
  };


  const validateForm = () => {
    const newErrors = {};
    if (!newStatus.status?.trim()) newErrors.status = 'Status is required';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    fetchStatuses();
    fetchData(getAll, { apiName: 'colours' }, setColourList);
  }, []);

  useEffect(() => {
    if (dtRef.current) {
      dtRef.current.destroy();
      dtRef.current = null;
    }
    if (statusList.length > 0) {
      dtRef.current = $(tableRef.current).DataTable({
        pageLength: 25,
        dom: 'rtp',
        responsive: false,
        language: {
          paginate: { first: '', last: '', next: '', previous: '' },
        },
      });
    }
    return () => {
      if (dtRef.current) {
        dtRef.current.destroy(true);
        dtRef.current = null;
      }
    };
  }, [statusList]);

  useEffect(() => {
    if (dtRef.current) {
      dtRef.current.search(searchTerm).draw();
    }
  }, [searchTerm]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewStatus((prev) => ({ ...prev, [name]: value }));
  };

  const handleEdit = (item) => {
    setNewStatus(item);
    setEditingId(item.id);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this status?')) return;
    try {
      await deletePlantStatus(id);
      // repaint the table
      if (dtRef.current) {
        dtRef.current.destroy();
        dtRef.current = null;
      }
      await fetchStatuses();
    } catch (error) {
      console.error('Error deleting status:', error);
    }
  };

  const handleSave = async () => {
    if (!validateForm()) return;
    try {
      const cleanPayload = {};
      for (const key in newStatus) {
        if (newStatus[key] !== null && typeof newStatus[key] !== 'object') {
          cleanPayload[key] = newStatus[key];
        }
      }

      if (editingId) {
        await updatePlantStatus(editingId, cleanPayload);
      } else {
        await createPlantStatus(cleanPayload);
      }

      setShowModal(false);
      setEditingId(null);

      // repaint the table
      if (dtRef.current) {
        dtRef.current.destroy();
        dtRef.current = null;
      }

      setNewStatus({});
      if (dtRef.current) dtRef.current.destroy();
      await fetchStatuses();
    } catch (error) {
      console.error('Error saving status:', error);
    }
  };

  return (
    <div className="card h-100 p-0 rounded-0">
      <div className="card-header d-flex justify-content-between align-items-center p-3">
        <input
          type="text"
          className="form-control w-auto"
          placeholder="Search..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        {userProfile?.privileges?.includes('plant-status:create') && (
          <button
            className="btn btn-primary text-sm btn-sm px-16 py-12 radius-4 d-flex align-items-center gap-2"
            onClick={() => {
              setNewStatus({});
              setEditingId(null);
              setShowModal(true);
            }}
          >
            <Icon icon="ic:baseline-plus" className="icon text-xl" />
            Add Asset Status
          </button>
        )}
      </div>

      <div className="card-body p-0">
        <div className="table-responsive scroll-sm">
          <table className="table bordered-table mb-0 w-100 rounded-0" ref={tableRef}>
            <thead>
              <tr>
                <th>Status</th>
                <th>Colour</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {statusList.map((item) => (
                <tr key={item.id}>
                  <td><strong>{item.status}</strong></td>
                  <td>
                    <span className={`d-inline-block rounded-1 bg-${item.colours?.bootstrapName}`} style={{ width: '10px', height: '10px', marginRight: '8px' }}></span>
                    {item.colours?.name}
                  </td>
                  <td>
                    <div className="d-flex gap-2">
                      {userProfile?.privileges?.includes('plant-status:update') && (
                          <button 
                            className="w-32-px h-32-px bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center mx-6"
                            onClick={() => handleEdit(item)}>
                              <Icon 
                                icon="ic:baseline-edit" 
                                  className="icon text-xl line-height-1" 
                            />
                          </button>
                      )}
                      {userProfile?.privileges?.includes('plant-status:delete') && (
                          <button 
                            className="w-32-px h-32-px bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center"
                            onClick={() => handleDelete(item.id)}>
                            <Icon 
                              icon="ic:baseline-delete-outline" 
                              className="icon text-xl line-height-1" 
                            />
                            </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {showModal && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{editingId ? 'Edit Asset Status' : 'New Asset Status'}</h5>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)} />
              </div>
              <div className="modal-body">
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label">Status *</label>
                    <input
                      className={`form-control ${errors.status ? 'is-invalid' : ''}`}
                      name="status"
                      value={newStatus.status || ''}
                      onChange={handleInputChange}
                    />
                    {errors.status && <div className="invalid-feedback">{errors.status}</div>}
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Colour Code</label>
                    <Select
                      name="coloursId"
                      classNamePrefix={`react-select ${errors.coloursId ? 'is-invalid' : ''}`}
                      value={colourOptions.find(opt => opt.value === newStatus.coloursId) || null}
                      onChange={(opt) =>
                        handleInputChange({ target: { name: 'coloursId', value: opt?.value || '' } })
                      }
                      options={colourOptions}
                      isClearable
                      placeholder="Select Colour"
                      formatOptionLabel={(opt) => (
                        <div className="d-flex align-items-center gap-2">
                          <span className={`d-inline-block rounded-1 bg-${opt.bootstrapName}`} style={{ width: '10px', height: '10px' }}></span>
                          {opt.label}
                        </div>
                      )}
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Close</button>
                <button className="btn btn-primary" onClick={handleSave}>Save</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PlantStatusListLayer;
